export const BLOG_SLUG = 'blog/';

export const DEFAULT_LANGUAGE: CountryCode = 'EN';

export const SITE_URL =
  process.env.BRANCH === 'staging'
    ? process.env.GATSBY_STAGING_WEBSITE_URL
    : process.env.GATSBY_WEBSITE_URL;
export const WORDPRESS_URL =
  process.env.BRANCH === 'staging'
    ? process.env.GATSBY_STAGING_WORDPRESS_URL
    : process.env.GATSBY_WORDPRESS_URL;
